import { MODAL_INITIAL_COUNTS, SCREEN_INITIAL_COUNTS } from './config'
import { useInModal } from '@components'

export function useCardInitialCounts():
  | typeof MODAL_INITIAL_COUNTS
  | typeof SCREEN_INITIAL_COUNTS {
  const inModal = useInModal()

  return inModal ? MODAL_INITIAL_COUNTS : SCREEN_INITIAL_COUNTS
}
